import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { RiDeleteBinLine } from "react-icons/ri";

const DeleteEmployeeModal = ({
  showDelete,
  setShowDelete,
  onConfirmDelete
}) => {
  return (
    <Modal
      show={showDelete}
      onHide={() => setShowDelete(false)}
      centered
      backdrop="static"
      contentClassName="border-0 shadow-none"
    >
      <Modal.Body
        style={{
          background: "#fff",
          borderRadius: "8px",
          textAlign: "center",
          padding: window.innerWidth < 576 ? "28px 20px" : "36px 30px",
          maxWidth: "500px",
          width: "100%",
          margin: "0 auto"
        }}
      >
        {/* Top Icon Box */}
        <div
          style={{
            width: window.innerWidth < 576 ? "72px" : "74px",
            height: window.innerWidth < 576 ? "72px" : "74px",
            background: "#FCE8E8",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px auto"
          }}
        >
          <RiDeleteBinLine
            style={{
              fontSize: window.innerWidth < 576 ? "34px" : "38px",
              color: "#ff0000"
            }}
          />
        </div>

        {/* Title */}
        <h4
          style={{
            fontSize: window.innerWidth < 576 ? "32px" : "24px",
            fontWeight: "700",
            color: "#253053",
            marginBottom: "10px",
            lineHeight: "1.2",
            fontFamily:
              "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          }}
        >
          Confirm Delete
        </h4>

        {/* Message */}
        <p
          style={{
            fontSize: window.innerWidth < 576 ? "15px" : "17px",
            fontWeight: "400",
            color: "#333",
            lineHeight: "1.45",
            maxWidth: "395px",
            margin: "0 auto 26px auto",
            fontFamily:
              "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          }}
        >
          You want to delete all the marked items, this cant be
          undone once you delete.
        </p>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: window.innerWidth < 576 ? "wrap" : "nowrap"
          }}
        >
          <Button
            onClick={() => setShowDelete(false)}
            style={{
              background: "#fff",
              border: "1px solid #D9D9D9",
              color: "#2E3445",
              height: "48px",
              minWidth: window.innerWidth < 576 ? "130px" : "92px",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "500",
              boxShadow: "none"
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={onConfirmDelete}
            style={{
              background: "#FF0000",
              border: "none",
              color: "#fff",
              height: "48px",
              minWidth: window.innerWidth < 576 ? "140px" : "124px",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "600",
              boxShadow: "none"
            }}
          >
            Yes, Delete
          </Button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default DeleteEmployeeModal;